import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Agency } from '@/modules/Agency/interfaces/agency'

import { showErrors } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { dateToNow } from '@/utils/dateTime'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTabs from '@/components/AppTabs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'

import AgencyDialog from '@/modules/Agency/scripts/agency-dialog'
import { getAgency } from '@/modules/Agency/gql/agency.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppTabs,
    AppDialog,
    AppTextSearch
  }
})

export default class AgencyDetail extends mixins(AgencyDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Settings'
    },
    {
      text: 'Agencies',
      to: { name: 'AgenciesList' }
    }
  ]

  agency: Agency | null = null

  tabActive = 0
  activeDelete = false
  tabItems = [
    {
      title: 'Details',
      route: 'AgencyDetailDetail'
    },
    {
      title: 'Additional',
      route: 'AgencyDetailAdditional'
    }
  ]

  disableConfirm = false

  @State(state => state.app.isFold) isFold!: boolean

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  dateToNow = dateToNow
  formatPhoneNumber = formatPhoneNumber

  async mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getAgency()
  }

  @Watch('$route.params.id')
  async onRouteParamUpdate (val: string) {
    this.getAgency()
  }

  async getAgency () {
    const agencyId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAgency,
        variables: {
          agencyId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.agency = result.data.getAgency as Agency
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async deleteAgencyConfirm () {
    await this.deleteAgencyPost()
    this.$router.replace({
      name: 'AgenciesList'
    })
  }
}
